
export class SimpleQueryFiltersResource {
    includeWords: string[];
    includeAnyWords: string[];
    excludeWords: string[];
    externalOnly: boolean;
    pubPrivConfGovtOnly: boolean;

    constructor(map: SimpleQueryFiltersResource = {} as SimpleQueryFiltersResource) {
        this.includeWords = map.includeWords || [];
        this.includeAnyWords = map.includeAnyWords || [];
        this.excludeWords = map.excludeWords || [];
        this.externalOnly = map.externalOnly || false;
        this.pubPrivConfGovtOnly = map.pubPrivConfGovtOnly || false;
    }
}
